import axios from 'axios';
import { GraphQLFetchPolicy } from '@getaccept/lib-shared/src/graphql/graphql-fetch-policy';
import bugsnagClient from '@getaccept/lib-shared/src/bugsnag';
import type { Resource } from '@getaccept/lib-shared/src/resources/types/resource';
import { apolloClientInternal } from '@getaccept/lib-shared/src/internal/apollo-client-internal';
import { TemplateGalleryQueries } from '../graphql/template-gallery.queries';
import type { GlobalTemplate } from '../../../template-gallery/types/global-template';
import type { LoadGlobalResourcesFilter } from '../../../template-gallery/types/load-resources-filter';

export class TemplateGalleryService {
  private static readonly documentId = 'document-id';

  static async loadGlobalResources(filter: LoadGlobalResourcesFilter): Promise<Resource[]> {
    const {
      data: {
        globalResources: { resources },
      },
    } = await apolloClientInternal.query({
      query: TemplateGalleryQueries.loadGlobalTemplatesQuery,
      variables: filter,
      fetchPolicy: GraphQLFetchPolicy.NetworkOnly,
    });
    return resources;
  }

  static async loadTemplate(documentId: string): Promise<GlobalTemplate> {
    const {
      data: { globalDocument },
    } = await apolloClientInternal.query({
      query: TemplateGalleryQueries.loadGlobalTemplate,
      variables: { documentId },
      fetchPolicy: GraphQLFetchPolicy.NetworkOnly,
    });
    return globalDocument;
  }

  static async sendOutTemplate(templateId: string): Promise<string> {
    const payload = new FormData();
    payload.append(this.documentId, templateId);
    let documentId = '';
    try {
      const {
        data: { document_id, error },
      } = await axios.post('/get/sample/document', payload);
      documentId = document_id;
      if (error) {
        throw new Error(error);
      }
    } catch (e) {
      if (bugsnagClient) {
        bugsnagClient.notify(e);
      }
    }
    return documentId;
  }

  static async copyTemplate(templateId: string): Promise<string> {
    const payload = new FormData();
    payload.append(this.documentId, templateId);

    const {
      data: { resource, error, status },
    } = await axios.post('/get/sample/template-resource', payload);
    if (error) {
      throw new Error(error);
    }
    if (status !== 1) {
      throw new Error(status);
    }

    return resource.id;
  }
}
